"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFriendlyInterfaceId = exports.getModuleDefaultDescription = exports.DependencySelector = exports.getProcessedHandle = exports.getSettingOptionsIfPresent = exports.getOverrideDefaultValue = exports.getSettingDefaultIfPresent = exports.getOptionValueByName = exports.getSettingFromComponent = exports.getSettingBits = exports.getRegisterValues = exports.hasConfigBits = exports.getComboOptions = exports.getDefaultValue = exports.castComponent = void 0;
var CalculateRegisterValue_1 = __importDefault(require("@microchip/scf-device/lib/CalculateRegisterValue"));
var Setting_1 = require("@microchip/scf-device/lib/Setting");
var Arrays_1 = require("@microchip/scf-device/lib/util/Arrays");
var Utils_1 = require("../Utils");
var getConfigData_1 = require("./getConfigData");
var castComponent = function (component) {
    switch (component.category) {
        case "software":
            return component;
        case "import":
            return component;
        case "hardware":
            return component;
        default:
            throw Error("Unsupported Component Type");
    }
};
exports.castComponent = castComponent;
var getDefaultValue = function (overrideDefaultValues, component) {
    var _a;
    return ((_a = overrideDefaultValues === null || overrideDefaultValues === void 0 ? void 0 : overrideDefaultValues(component.name)) !== null && _a !== void 0 ? _a : (component.type === "ComboBox"
        ? component.defaultValue.value
        : component.defaultValue));
};
exports.getDefaultValue = getDefaultValue;
var getComboOptions = function (overrideOptions, component) {
    var _a, _b;
    return (_a = overrideOptions === null || overrideOptions === void 0 ? void 0 : overrideOptions(component.name)) !== null && _a !== void 0 ? _a : (_b = component === null || component === void 0 ? void 0 : component.defaultValue) === null || _b === void 0 ? void 0 : _b["options"];
};
exports.getComboOptions = getComboOptions;
var hasConfigBits = function (interfaceName) {
    var _a;
    return ((_a = (0, exports.getFriendlyInterfaceId)(interfaceName)) === null || _a === void 0 ? void 0 : _a.indexOf("configuration_bits")) != -1;
};
exports.hasConfigBits = hasConfigBits;
var getRegisterValues = function (model, interfaceName) {
    var _a;
    var registers = {};
    var config = (0, getConfigData_1.getConfigData)(model);
    interfaceName = (0, exports.getFriendlyInterfaceId)(interfaceName);
    (_a = config === null || config === void 0 ? void 0 : config.peripherals) === null || _a === void 0 ? void 0 : _a.forEach(function (peripheral) {
        var _a, _b, _c;
        var peripheralName = (_a = (0, exports.getFriendlyInterfaceId)(peripheral.interfaceId.name)) !== null && _a !== void 0 ? _a : "";
        if ((0, exports.hasConfigBits)(peripheralName))
            return;
        if ((interfaceName != undefined && peripheralName !== interfaceName) ||
            !peripheral.registers)
            return;
        (_c = (0, Utils_1.getKeys)((_b = peripheral.registers) !== null && _b !== void 0 ? _b : {})) === null || _c === void 0 ? void 0 : _c.forEach(function (regName) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var registerValue;
            var reg = (_b = (_a = model.getHardware(peripheralName)) === null || _a === void 0 ? void 0 : _a.getPeripheral().registers) === null || _b === void 0 ? void 0 : _b[regName];
            if (reg) {
                registerValue = {
                    comment: "",
                    value: 0,
                    valueAsHex: "0x00",
                    name: reg === null || reg === void 0 ? void 0 : reg.name,
                    alias: (_c = reg === null || reg === void 0 ? void 0 : reg.alias) !== null && _c !== void 0 ? _c : reg === null || reg === void 0 ? void 0 : reg.name,
                    settings: {},
                };
            }
            else {
                return;
            }
            var registerVal = CalculateRegisterValue_1.default.for(reg);
            var comments = [];
            (_d = peripheral.registers) === null || _d === void 0 ? void 0 : _d[regName].forEach(function (set) {
                var _a, _b, _c, _d, _e;
                var setting = (_a = reg.settings) === null || _a === void 0 ? void 0 : _a[set.setting];
                if (setting) {
                    if (setting.type !== "R") {
                        //Add Comments
                        comments.push("".concat(set.setting, " ").concat(model.getComponentValue(set.name), "; "));
                    }
                    if (registerValue === null || registerValue === void 0 ? void 0 : registerValue.settings) {
                        registerValue.settings[setting.alias] = (0, exports.getSettingBits)(reg, setting, (_b = model.getComponent(set.name)) === null || _b === void 0 ? void 0 : _b.value, (_c = config === null || config === void 0 ? void 0 : config.deviceType) !== null && _c !== void 0 ? _c : "PIC");
                    }
                    switch (set.type) {
                        case "ComboBox":
                        case "boolean":
                            registerVal.withNumberValue(setting, (_e = (0, exports.getOptionValueByName)(setting, (_d = model.getComponent(set.name)) === null || _d === void 0 ? void 0 : _d.value)) !== null && _e !== void 0 ? _e : 0);
                            break;
                        case "number":
                            registerVal.withNumberValue(setting, model.getComponentValue(set.name));
                            break;
                        case "register":
                        case "string":
                            registerVal.withNumberValue(setting, Number(model.getComponentValue(set.name)));
                            break;
                        default:
                            break;
                    }
                }
            });
            if (reg.settings) {
                registerValue.value = registerVal.asNumber();
            }
            else {
                registerValue.value = Number((_j = model.getComponentValue((_h = (_g = (_f = (_e = peripheral.registers) === null || _e === void 0 ? void 0 : _e[regName]) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : "")) !== null && _j !== void 0 ? _j : 0);
                comments.push("".concat(registerValue.name, " ").concat(registerValue.value, "; "));
            }
            registerValue.valueAsHex =
                "0x" + registerValue.value.toString(16).toUpperCase();
            registerValue.comment = sortComments(comments, reg);
            registers[(_k = reg === null || reg === void 0 ? void 0 : reg.alias) !== null && _k !== void 0 ? _k : reg.name] = registerValue;
        });
    });
    return registers;
};
exports.getRegisterValues = getRegisterValues;
var sortComments = function (comments, register) {
    comments.sort(function (a, b) {
        var _a, _b, _c, _d;
        var settingA = (_a = register.settings) === null || _a === void 0 ? void 0 : _a[(_b = a.split[" "]) === null || _b === void 0 ? void 0 : _b[0]];
        var settingB = (_c = register.settings) === null || _c === void 0 ? void 0 : _c[(_d = b.split(" ")) === null || _d === void 0 ? void 0 : _d[0]];
        return Number(settingB === null || settingB === void 0 ? void 0 : settingB.mask) - Number(settingA === null || settingA === void 0 ? void 0 : settingA.mask);
    });
    return comments.join("");
};
var getSettingBits = function (register, setting, value, deviceType) {
    var _a, _b;
    var setValNumber = Number((_b = (_a = (0, Setting_1.getOptionByAlias)(value, setting)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 0);
    var settingValue = {
        alias: setting.alias,
        name: setting.name,
        value: setValNumber !== null && setValNumber !== void 0 ? setValNumber : 0,
        valueAsHex: "0x" + setValNumber.toString(16).toUpperCase(),
        valueAsDescription: value,
        bitName: deviceType === "PIC"
            ? "".concat(register.name, "bits.").concat(setting.name)
            : "".concat(register.name, ".").concat(setting.name),
    };
    return settingValue;
};
exports.getSettingBits = getSettingBits;
var getRegisterFromComponent = function (hardware, component) {
    var _a, _b, _c, _d, _e;
    var registerName = (_a = component.name
        .replace(component.setting.toLowerCase(), "")) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    var register = (_b = hardware === null || hardware === void 0 ? void 0 : hardware.registers) === null || _b === void 0 ? void 0 : _b[registerName];
    if (register) {
        return register;
    }
    else {
        var regName = (_c = component.name
            .replace(component.setting.toLowerCase(), "")) === null || _c === void 0 ? void 0 : _c.toUpperCase();
        var registers = (0, Utils_1.getKeys)((_d = hardware === null || hardware === void 0 ? void 0 : hardware.registers) !== null && _d !== void 0 ? _d : {});
        for (var _i = 0, _f = registers !== null && registers !== void 0 ? registers : []; _i < _f.length; _i++) {
            var reg = _f[_i];
            var modifiedRegName = reg.replace(/_/g, "");
            if (regName === modifiedRegName) {
                return (_e = hardware === null || hardware === void 0 ? void 0 : hardware.registers) === null || _e === void 0 ? void 0 : _e[reg];
            }
        }
    }
};
var getSettingFromComponent = function (model, component) {
    var _a;
    var config = (0, getConfigData_1.getConfigData)(model);
    var setting;
    if (model) {
        (_a = config === null || config === void 0 ? void 0 : config.peripherals) === null || _a === void 0 ? void 0 : _a.forEach(function (peripheral) {
            var _a, _b, _c;
            if (setting)
                return;
            var peripheralName = (0, exports.getFriendlyInterfaceId)(peripheral.interfaceId.name);
            var hardware = (_a = model.getHardware(peripheralName)) === null || _a === void 0 ? void 0 : _a.getPeripheral();
            var register = getRegisterFromComponent(hardware, component);
            if (register && !register.settings) {
                //No settings for this particular register. Create one
                setting = {
                    alias: (_b = register.alias) !== null && _b !== void 0 ? _b : register.name,
                    name: register.name,
                    defaultValue: register.defaultValue,
                    type: register.type,
                    description: register.desc,
                    porDefault: register.defaultValue,
                };
            }
            else {
                setting = (_c = register === null || register === void 0 ? void 0 : register.settings) === null || _c === void 0 ? void 0 : _c[component.setting];
            }
        });
    }
    return setting;
};
exports.getSettingFromComponent = getSettingFromComponent;
var getOptionValueByName = function (setting, optionName) {
    if (!setting)
        return undefined;
    var optionValue = setting.porDefault;
    if (setting.options) {
        setting.options.forEach(function (option) {
            if (option.name === optionName || option.description === optionName) {
                optionValue = option.value;
            }
        });
    }
    return Number(optionValue);
};
exports.getOptionValueByName = getOptionValueByName;
var getSettingDefaultIfPresent = function (component, setting, overrideDefaultValue) {
    var _a, _b;
    var defaultValue;
    if (overrideDefaultValue !== undefined) {
        return overrideDefaultValue;
    }
    if (component.overrideDefaultValue) {
        return component.overrideDefaultValue;
    }
    if (setting === null || setting === void 0 ? void 0 : setting.defaultValue) {
        var option = (0, Setting_1.getOptionByName)(setting.defaultValue, setting);
        defaultValue =
            (_b = option === null || option === void 0 ? void 0 : option[(_a = component.displayOptionSetting) !== null && _a !== void 0 ? _a : "alias"]) !== null && _b !== void 0 ? _b : setting.defaultValue;
    }
    return defaultValue;
};
exports.getSettingDefaultIfPresent = getSettingDefaultIfPresent;
var getOverrideDefaultValue = function (component, model) {
    var _a, _b;
    return (_b = (_a = model.getDerivedFunctions()).overrideDefaultValues) === null || _b === void 0 ? void 0 : _b.call(_a, component.name);
};
exports.getOverrideDefaultValue = getOverrideDefaultValue;
var getSettingOptionsIfPresent = function (component, setting, masterComponentValue) {
    var _a;
    var options = [""];
    if (setting) {
        var filteredOptions = component.mode
            ? filterModeOptions((_a = setting.options) !== null && _a !== void 0 ? _a : [], component, masterComponentValue)
            : setting.options;
        options = (0, Arrays_1.map)(filteredOptions !== null && filteredOptions !== void 0 ? filteredOptions : [], function (option) { var _a, _b; return (_b = option[(_a = component.displayOptionSetting) !== null && _a !== void 0 ? _a : "alias"]) !== null && _b !== void 0 ? _b : option.alias; });
    }
    return options;
};
exports.getSettingOptionsIfPresent = getSettingOptionsIfPresent;
var filterModeOptions = function (options, component, masterComponentValue) {
    var _a, _b, _c, _d;
    if (((_a = component.mode) === null || _a === void 0 ? void 0 : _a.operation) != "filterOptions" || masterComponentValue == undefined)
        return options;
    //Determine mode
    var mode = (0, Arrays_1.find)((_d = (0, Utils_1.getKeys)((_c = (_b = component.mode) === null || _b === void 0 ? void 0 : _b.optionModes) !== null && _c !== void 0 ? _c : {})) !== null && _d !== void 0 ? _d : [], function (mode) {
        var _a, _b, _c, _d;
        var match = (_b = (_a = component.mode) === null || _a === void 0 ? void 0 : _a.optionModes) === null || _b === void 0 ? void 0 : _b[mode];
        if (match) {
            return ((_d = (_c = masterComponentValue === null || masterComponentValue === void 0 ? void 0 : masterComponentValue.match(match)) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : -1) > 0;
        }
        return false;
    });
    var filteredOptions = (0, Arrays_1.filter)(options !== null && options !== void 0 ? options : [], function (option) {
        var _a, _b, _c, _d;
        if (option.mode && mode) {
            var match = (_b = (_a = component.mode) === null || _a === void 0 ? void 0 : _a.optionModes) === null || _b === void 0 ? void 0 : _b[mode];
            if (match) {
                return ((_d = (_c = option.mode.match(match)) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : -1) > 0;
            }
        }
        return true;
    });
    return filteredOptions;
};
var getProcessedHandle = function (handle, payload) {
    var _a, _b, _c;
    if (handle) {
        handle = __assign(__assign({}, handle), { label: (_c = (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.moduleName) !== null && _a !== void 0 ? _a : payload === null || payload === void 0 ? void 0 : payload.name) !== null && _b !== void 0 ? _b : handle.label) !== null && _c !== void 0 ? _c : handle.providerId + " : " + handle.exportId });
    }
    return handle;
};
exports.getProcessedHandle = getProcessedHandle;
var DependencySelector = /** @class */ (function () {
    function DependencySelector(model, component) {
        var _this = this;
        this.noneSelection = { label: "None" };
        this.createOptionEntry = function (option) {
            return {
                label: _this.createOptionLabel(option.handle, option.payload),
                value: option,
            };
        };
        this.createOptionLabel = function (handle, payload) {
            var _a, _b;
            return (_b = (_a = (0, exports.getProcessedHandle)(handle, payload)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : "";
        };
        this.model = model;
        this.component = component;
    }
    DependencySelector.prototype.generateDropdownOptions = function () {
        var dropdownOptions = [];
        var thisImport = this.model.getImports()[this.component.importId];
        var options = thisImport === null || thisImport === void 0 ? void 0 : thisImport.options;
        if (this.shouldAllowUnselectDependency(thisImport, options)) {
            dropdownOptions.push(this.noneSelection);
        }
        if (options) {
            for (var option in options) {
                dropdownOptions.push(this.createOptionEntry(options[option]));
            }
        }
        return dropdownOptions;
    };
    DependencySelector.prototype.getDropdownOptionNames = function () {
        var names = [];
        this.generateDropdownOptions().forEach(function (option) { return names.push(option.label); });
        return names;
    };
    DependencySelector.prototype.shouldAllowUnselectDependency = function (thisImport, options) {
        return (thisImport != undefined &&
            thisImport.isUnassignable != false &&
            options !== undefined);
    };
    return DependencySelector;
}());
exports.DependencySelector = DependencySelector;
function getModuleDefaultDescription() {
    //TODO: Need to refactor this so that gets it from the source.
    //Alternatively, we could get it during the automodule update process and fetch it from there...
    return undefined;
}
exports.getModuleDefaultDescription = getModuleDefaultDescription;
var getFriendlyInterfaceId = function (interfaceName) {
    interfaceName = interfaceName === null || interfaceName === void 0 ? void 0 : interfaceName.replace(/ /g, "").replace(/-/g, "_");
    return interfaceName;
};
exports.getFriendlyInterfaceId = getFriendlyInterfaceId;
//# sourceMappingURL=AutoModuleHelpers.js.map